import React from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CButton,
  CNav,
  CNavLink,
  CNavItem,
  CTabContent,
  CTabPane,
  CCard,
  CCardBody,
  CFormSelect,
  CContainer,
  CRow,
  CForm,
  CFormInput,
  CCol,
  CFormCheck,
  CFormTextarea,
  CLoadingButton,
  CDatePicker,
  CTable,
  CTableHead,
  CTableHeaderCell,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CSpinner,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import {cilX} from '@coreui/icons';
import styles from './CashBids.module.css';
import moment from 'moment';
import {
  hidePurchaseContractModal,
  userCancelledPurchaseContract,
  setPurchaseContractModalActiveTabIndex,
  setPurchaseContractType,
  setPurchaseContractNumberOfBushels,
  setPurchaseContractSettleGrain,
  setPurchaseContractSettleGrainPaymentType,
  setPurchaseContractComments,
  setPurchaseContractAgreeToTerms,
  setPurchaseContractSignature,
  savePurchaseContract,
  hidePurchaseContractSuccessModal,
  setOfferCashPrice,
  setOfferExpirationDate,
  saveOffer,
  userTappedCancelOffer,
  hideCancelOfferModal,
  userCancelledOffer,
  hidePurchaseContractInvalidBushelsModal,
  setPurchaseContractApplyToExistingContract,
  setPurchaseContractExistingContractNumber,
} from './cashBids-actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const PurchaseContractModal = () => {

  const dispatch = useDispatch();

  const {
    purchaseContractModalIsVisible,
    purchaseContractModalActiveTabIndex,
    purchaseContractCashBid,
    purchaseContractLocation,
    purchaseContractType,
    purchaseContractNumberOfBushels,
    purchaseContractSettleGrain,
    purchaseContractSettleGrainPaymentType,
    purchaseContractComments,
    purchaseContractAgreeToTerms,
    purchaseContractSignature,
    savingPurchaseContract,
    purchaseContractSuccessModalIsVisible,
    newPurchaseContractNumber,
    isMakeOfferInterface,
    offerCashPrice,
    offerExpirationDate,
    offerCreationSuccess,
    fetchingOffers,
    offers,
    cancelOfferModalIsVisible,
    cancellingOffer,
    purchaseContractInvalidBushelsModalIsVisible,
    purchaseContractHTAFee,
    purchaseContractPrice,
    purchaseContractApplyToExistingContract,
    purchaseContractExistingContractNumber,
  } = useSelector(state => state.cashBids);

  const agvanceUser = useSelector(state => state.auth.authorization.agvanceUser);

  return (
    <>
      <CModal
        fullscreen
        alignment='center'
        scrollable 
        visible={purchaseContractModalIsVisible}>
        <CModalHeader closeButton={false}>
          <CModalTitle className={styles.cashBidsModalTitle}>
            {
              isMakeOfferInterface === false ?
                'Create Purchase Contract' :
                'Create Offer'
            }
          </CModalTitle>
          <CButton className={styles.modalCloseButton} onClick={() => dispatch(hidePurchaseContractModal())}>
            <CIcon className={styles.modalCloseButtonIcon} icon={cilX} />
          </CButton>
        </CModalHeader>
        <CModalBody className={styles.cashBidsModalBody}>
          <CNav variant='pills' role='tablist' layout='fill'>
            <CNavItem>
              <CNavLink
                href='#!'
                disabled={savingPurchaseContract}
                active={purchaseContractModalActiveTabIndex === 0}
                onClick={(event) => {
                  event.preventDefault();
                  dispatch(setPurchaseContractModalActiveTabIndex(0));
                }}>
                Step 1
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                href='#!'
                active={purchaseContractModalActiveTabIndex === 1}
                disabled={!(purchaseContractNumberOfBushels > 0) || savingPurchaseContract}
                onClick={(event) => {
                  event.preventDefault();
                  if (purchaseContractNumberOfBushels > 0) {
                    dispatch(setPurchaseContractModalActiveTabIndex(1));
                  }
                }}>
                Step 2
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                href='#!'
                active={purchaseContractModalActiveTabIndex === 2}
                disabled={(!(purchaseContractAgreeToTerms === true && purchaseContractSignature?.length > 0)) || savingPurchaseContract}
                onClick={(event) => {
                  event.preventDefault();
                  dispatch(setPurchaseContractModalActiveTabIndex(2));
                }}>
                Step 3
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent>
            <CTabPane role='tabpanel' visible={purchaseContractModalActiveTabIndex === 0}>
              <CContainer fluid>
                <CCard>
                  <CCardBody>
                    <CForm
                      onSubmit={async (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        dispatch(setPurchaseContractModalActiveTabIndex(1));
                      }}
                      style={{
                        padding: 20,
                        paddingTop: 0,
                        width: '90%',
                      }}>
                      <div className='mb-3' style={{flexDirection: 'row', display: 'flex',}}>
                        <div style={{margin: 10, width: isMakeOfferInterface === false ? 1000 : 700,}}>
                          <CRow className='mb-3'>
                            <CCol xs={4}>
                              <CFormSelect
                                floatingLabel='Contract Type'
                                style={{width: 300, lineHeight: 4,}}
                                options={[
                                  {label: 'Priced', value: 'Priced',},
                                  {label: 'Basis', value: 'Basis',},
                                  {label: 'HTA (Hedge To Arrive)', value: 'HTA',},
                                ]}
                                value={purchaseContractType}
                                onChange={(e) => dispatch(setPurchaseContractType(e.target.value))}
                              />
                            </CCol>
                          </CRow>
                          <CRow className='mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                floatingLabel='Customer'
                                type='text'
                                id='customer'
                                style={{width: 300,}}
                                value={agvanceUser?.firstName + ' ' + agvanceUser?.lastName}
                              />
                            </CCol>
                            {
                              isMakeOfferInterface === false && (purchaseContractType === 'Priced' || purchaseContractType === 'HTA') ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    floatingLabel='Futures Price'
                                    type='text'
                                    id='lastPrice'
                                    style={{width: 300,}}
                                    value={purchaseContractCashBid?.futures.lastPrice}
                                  />
                                </CCol>
                              ) : null
                            }
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                floatingLabel='Location'
                                type='text'
                                id='location'
                                style={{width: 300,}}
                                value={purchaseContractLocation?.locationName}
                              />
                            </CCol>
                            {
                              isMakeOfferInterface === false && (purchaseContractType === 'Priced' || purchaseContractType === 'Basis') ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    floatingLabel='Basis'
                                    type='text'
                                    id='basis'
                                    style={{width: 300,}}
                                    value={purchaseContractCashBid?.basis / 100}
                                  />
                                </CCol>
                              ) : null
                            }
                            {
                              isMakeOfferInterface === false && purchaseContractType === 'HTA' ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    floatingLabel='HTA Fee'
                                    type='number'
                                    id='htaFee'
                                    style={{width: 300,}}
                                    value={parseFloat(purchaseContractHTAFee || 0).toFixed(2)}
                                  />
                                </CCol>
                              ) : null
                            }
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                floatingLabel='Commodity'
                                type='text'
                                id='commodity'
                                style={{width: 300,}}
                                value={purchaseContractCashBid?.commodity}
                              />
                            </CCol>
                            {
                              isMakeOfferInterface === false && purchaseContractType === 'Priced' ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    floatingLabel='Cash Price'
                                    type='text'
                                    id='cashPrice'
                                    style={{width: 300,}}
                                    value={'$' + purchaseContractCashBid?.cashprice}
                                  />
                                </CCol>
                              ) : null
                            }
                            {
                              isMakeOfferInterface === false && purchaseContractType === 'HTA' ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    floatingLabel='Contract Price'
                                    type='text'
                                    id='contractPrice'
                                    style={{width: 300,}}
                                    value={purchaseContractPrice}
                                  />
                                </CCol>
                              ) : null
                            }
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                floatingLabel='Delivery Start Date'
                                type='text'
                                id='startDate'
                                style={{width: 300,}}
                                value={moment(purchaseContractCashBid?.delivery_start).format('M/DD/YYYY')}
                              />
                            </CCol>
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                floatingLabel='Delivery End Date'
                                type='text'
                                id='endDate'
                                style={{width: 300,}}
                                value={moment(purchaseContractCashBid?.delivery_end).format('M/DD/YYYY')}
                              />
                            </CCol>
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                required
                                floatingLabel='Number of Bushels'
                                type='number'
                                id='bushels'
                                style={{width: 300,}}
                                value={purchaseContractNumberOfBushels}
                                onChange={(e) => dispatch(setPurchaseContractNumberOfBushels(e.target.value))} 
                              />
                            </CCol>
                          </CRow>
                          {
                              isMakeOfferInterface === true ? (
                                <CRow className='mt-2 mb-3'>
                                  <CCol xs={4}>
                                    <CFormInput
                                      required
                                      floatingLabel='Cash Price'
                                      type='number'
                                      id='offerCashPrice'
                                      style={{width: 300,}}
                                      value={offerCashPrice}
                                      onChange={(e) => dispatch(setOfferCashPrice(e.target.value))} 
                                    />
                                  </CCol>
                                </CRow>
                              ) : null
                            }
                          {
                            isMakeOfferInterface === true ? (
                              <CRow className='mt-2 mb-1'>
                                <CCol xs={4}>
                                  <CDatePicker
                                    locale='en-US'
                                    style={{height: 58, width: 300,}}
                                    label='Expiration Date'
                                    date={offerExpirationDate}
                                    placeholder={'Select Expiration Date'}
                                    id='expirationDate'
                                    inputReadOnly={true}
                                    minDate={purchaseContractCashBid.delivery_start}
                                    maxDate={purchaseContractCashBid.delivery_end}
                                    onDateChange={(date) => dispatch(setOfferExpirationDate(date))} />
                                </CCol>
                              </CRow>
                            ) : null
                          }
                          {
                            isMakeOfferInterface === false ? (
                              <>
                                <CRow className='mt-2 mb-3'>
                                  <CCol xs={4}>
                                    <CFormCheck 
                                      id='settleGrain' 
                                      label='Do you want this grain to be settled?'
                                      value={purchaseContractSettleGrain}
                                      onChange={(e) => dispatch(setPurchaseContractSettleGrain(e.target.checked))}
                                    />
                                  </CCol>
                                  {
                                    purchaseContractType === 'Basis' || purchaseContractType === 'HTA' ? (
                                      <CCol xs={4}>
                                        <CFormCheck 
                                          id='purchaseContractApplyToExistingContract' 
                                          label='Do you want this contract to be applied against an existing contract?'
                                          value={purchaseContractApplyToExistingContract}
                                          onChange={(e) => dispatch(setPurchaseContractApplyToExistingContract(e.target.checked))}
                                        />
                                      </CCol>
                                    ) : null
                                  }
                                </CRow>
                                <CRow className='mt-2 mb-3'>
                                  <CCol xs={4}>
                                    <CFormSelect 
                                      disabled={!purchaseContractSettleGrain}
                                      style={{width: 300,}}
                                      options={[
                                        {label: 'ACH', value: 'ACH',},
                                        {label: 'Check', value: 'Check',},
                                        {label: 'Deferred Payment', value: 'Deferred Payment',}
                                      ]}
                                      value={purchaseContractSettleGrainPaymentType}
                                      onChange={(e) => dispatch(setPurchaseContractSettleGrainPaymentType(e.target.value))}
                                    />
                                  </CCol>
                                  {
                                    purchaseContractType === 'Basis' || purchaseContractType === 'HTA' ? (
                                      <CCol xs={4}>
                                        <CFormInput
                                          disabled={!purchaseContractApplyToExistingContract}
                                          floatingLabel='Existing Contract Number'
                                          type='text'
                                          id='purchaseContractExistingContractNumber'
                                          style={{width: 300,}}
                                          value={purchaseContractExistingContractNumber}
                                          onChange={(e) => dispatch(setPurchaseContractExistingContractNumber(e.target.value))} 
                                        />
                                      </CCol>
                                    ) : null
                                  }
                                </CRow>
                              </>
                            ) : null
                          }
                          <CRow>
                            <CCol xs={4}>
                              <CFormTextarea
                                type='text'
                                id='comments'
                                placeholder='Please let us know about any special requests you may have.'
                                style={{width: 640, height: 70,}}
                                value={purchaseContractComments}
                                onChange={(e) => dispatch(setPurchaseContractComments(e.target.value))}
                              />
                            </CCol>
                          </CRow>
                        </div>
                        {
                          isMakeOfferInterface === true ? (
                            <div>
                              <CModalTitle className={styles.cashBidsModalTitle}>My Existing Open Offers</CModalTitle>
                              {
                                fetchingOffers === true ? (
                                  <CSpinner color='primary' className={styles.loadingSpinner} />
                                ) : null
                              }
                              <CTable className={styles.cashBidsTable}>
                                <CTableHead className={styles.cbTableHead}>
                                  <CTableRow>
                                    <CTableHeaderCell>Location</CTableHeaderCell>
                                    <CTableHeaderCell>Commodity</CTableHeaderCell>
                                    <CTableHeaderCell>Status</CTableHeaderCell>
                                    <CTableHeaderCell>Delivery Start</CTableHeaderCell>
                                    <CTableHeaderCell>Expiration Date</CTableHeaderCell>
                                    <CTableHeaderCell>Bushels</CTableHeaderCell>
                                    <CTableHeaderCell>Cash Price</CTableHeaderCell>
                                    <CTableHeaderCell>Date Entered</CTableHeaderCell>
                                    <CTableHeaderCell></CTableHeaderCell>
                                  </CTableRow>
                                </CTableHead>
                                <CTableBody className={styles.cbTableBody}>
                                {
                                  offers.filter(offer => offer.node.status !== 'ACCEPTED').map((offer, index) => (
                                    <CTableRow key={'offer' + index} className={styles.cbTableRow}>
                                      <CTableDataCell>{offer.node.location.name}</CTableDataCell>
                                      <CTableDataCell>{offer.node.commodity.name}</CTableDataCell>
                                      <CTableDataCell>{offer.node.status}</CTableDataCell>
                                      <CTableDataCell>{offer.node.cashBid === null ? '' : moment(offer.node.cashBid.deliveryStart).format('M/D/yyy')}</CTableDataCell>
                                      <CTableDataCell>{moment(offer.node.expirationDate).format('M/D/yyy')}</CTableDataCell>
                                      <CTableDataCell>{offer.node.quantity}</CTableDataCell>
                                      <CTableDataCell>${offer.node.price}</CTableDataCell>
                                      <CTableDataCell>{moment(offer.node.createdAt).format('M/D/yyy')}</CTableDataCell>
                                      <CTableDataCell>
                                        <button 
                                          disabled={offer.node.status !== 'PENDING' && offer.node.status !== 'ACKNOWLEDGED' && offer.node.status !== 'ACCEPTED'}
                                          className={
                                            offer.node.status !== 'PENDING' && offer.node.status !== 'ACKNOWLEDGED' && offer.node.status !== 'ACCEPTED' ?
                                              styles.cancelOfferButtonDisabled :
                                              styles.cancelOfferButton
                                          }
                                          onClick={(e) => {
                                            dispatch(userTappedCancelOffer(offer.node.id));
                                            e.stopPropagation();
                                            e.preventDefault();
                                          }}>
                                          Cancel Offer
                                        </button>
                                      </CTableDataCell>
                                    </CTableRow>
                                  ))
                                }
                                </CTableBody>
                              </CTable>
                            </div>
                          ) : null
                        }
                      </div>
                      <div className='mt-1'>
                        <CButton
                          color='primary'
                          onClick={() => dispatch(userCancelledPurchaseContract())}>
                          Cancel
                        </CButton>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {
                          isMakeOfferInterface === false && purchaseContractNumberOfBushels > 0 ? (
                            <CButton
                              type='submit'
                              color='primary'>
                              Agree to Terms
                            </CButton>
                          ) : null
                        }
                        {
                          isMakeOfferInterface === true && purchaseContractNumberOfBushels > 0 && offerCashPrice > 0 && offerExpirationDate !== null ? (
                            <CButton
                              type='submit'
                              color='primary'>
                              Agree to Terms
                            </CButton>
                          ) : null
                        }
                      </div>
                    </CForm>
                  </CCardBody>
                </CCard>
              </CContainer>
            </CTabPane>
            <CTabPane role='tabpanel' visible={purchaseContractModalActiveTabIndex === 1}>
              <CContainer fluid>
                <CCard>
                  <CCardBody>
                    <CForm
                      onSubmit={async (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        dispatch(setPurchaseContractModalActiveTabIndex(2));
                      }}
                      style={{
                        padding: 20,
                        paddingTop: 0,
                        width: '90%',
                      }}>
                      <div className='mb-3'>
                        <div style={{margin: 10,}}>
                          <CRow>
                            <CCol xs={4}>
                              <CFormTextarea
                                readOnly={true}
                                type='text'
                                id='agreement'
                                style={{width: 800, height: 400,}}
                                value={'1. The Seller hereby sells and agrees to deliver, and the Buyer hereby purchases and agrees to receive grain according to the terms specified above. Grain received at grades other than those specified above shall be subject to market scale of discounts in effect at time of delivery. Buyer reserves the right to reject any grain of a distinctly lower quality than that specified above.\n\n' +
                                      '2. Seller warrants that all grain to be delivered here under will be free and clear of any and all liens and encumbrances and that Seller has good and merchantable title with the right to dispose of the grain.\n\n' + 
                                      '3. Should Buyer be unable to accept delivery when Seller tenders grain, Seller shall hold the grain for delivery to the buyer at a time as soon thereafter as Buyer can receive delivery. Buyer may designate any reasonable alternative delivery point to expedite Seller\'s performance on this contract but shall not have the obligation to do so.\n\n' +
                                      '4. Seller agrees to reimburse Buyer for any losses sustained by Buyer as a result of the Seller\'s failure to perform on this contract.\n\n' +
                                      '5. Article 2 of the Uniform Commercial Code as adopted by the State of Illinois shall be deemed a part of this contract as if fully set out herein. Unless otherwise agreed, this contract is subject to the Grain Trade Rules of the National Grain and Feed Association. Further, Buyer and Seller agree that any dispute regarding this contract will be resolved through arbitration rules of the National Grain and Feed Association and the results of any such arbitration shall be accepted by Buyer and Seller as the final resolution of the dispute.\n\n' +
                                      '6. Buyer shall have the option to cancel this contract at any time prior to the receipt of the duplicate copy of this contract signed by the Seller unless duplicate is returned within 5 days from the date hereof or performance has commenced.\n\n' +
                                      'Note: This contract is a delivery obligation to the seller.'}
                              />
                            </CCol>
                          </CRow>
                          <CRow className='mt-4 mb-3'>
                            <CCol xs={4}>
                              <CFormCheck 
                                id='acceptTerms' 
                                label={isMakeOfferInterface === true ? 'Agree to offer terms' : 'Agree to contract terms'}
                                value={purchaseContractAgreeToTerms}
                                onChange={(e) => dispatch(setPurchaseContractAgreeToTerms(e.target.checked))}
                              />
                            </CCol>
                          </CRow>
                          <CRow className='mt-4 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                floatingLabel='Customer'
                                type='text'
                                id='customer'
                                style={{width: 500,}}
                                value={agvanceUser?.firstName + ' ' + agvanceUser?.lastName}
                              />
                            </CCol>
                          </CRow>
                          <CRow>
                            <CCol xs={4}>
                              <CFormInput
                                required
                                placeholder='E-Signature (type your name exactly as shown above)'
                                style={{width: 500,}}
                                type='text'
                                id='signature'
                                value={purchaseContractSignature}
                                onChange={(e) => dispatch(setPurchaseContractSignature(e.target.value))}
                              />
                            </CCol>
                          </CRow>
                          <div className='mt-5'>
                            <CButton
                              color='primary'
                              onClick={() => dispatch(userCancelledPurchaseContract())}>
                              Cancel
                            </CButton>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {
                              purchaseContractAgreeToTerms === true && purchaseContractSignature?.length > 0 ? (
                                <CButton
                                  type='submit'
                                  color='primary'>
                                  {isMakeOfferInterface === false ? 'Confirm Contract Details' : 'Confirm Offer Details'}
                                </CButton>
                              ) : null
                            }
                          </div>
                        </div>
                      </div>
                    </CForm>
                  </CCardBody>
                </CCard>
              </CContainer>
            </CTabPane>
            <CTabPane role='tabpanel' visible={purchaseContractModalActiveTabIndex === 2}>
            <CContainer fluid>
                <CCard>
                  <CCardBody>
                    <CForm
                      onSubmit={async (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      style={{
                        padding: 20,
                        paddingTop: 0,
                        width: '90%',
                      }}>
                      <div className='mb-3'>
                        <div style={{margin: 10, width: 1000,}}>
                          <CRow className='mb-3'>
                            <CCol xs={4}>
                              <CFormSelect
                              disabled={true}
                                floatingLabel='Contract Type'
                                style={{width: 300, lineHeight: 4,}}
                                options={[
                                  {label: 'Basis', value: 'Basis',},
                                  {label: 'HTA (Hedge To Arrive)', value: 'HTA',},
                                  {label: 'Priced', value: 'Priced',}
                                ]}
                                value={purchaseContractType}
                              />
                            </CCol>
                          </CRow>
                          <CRow>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                placeholder='Customer...'
                                floatingLabel='Customer'
                                type='text'
                                id='customer'
                                style={{width: 300,}}
                                value={agvanceUser?.firstName + ' ' + agvanceUser?.lastName}
                              />
                            </CCol>
                            {
                              isMakeOfferInterface === false && (purchaseContractType === 'Priced' || purchaseContractType === 'HTA') ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    placeholder='Futures Price...'
                                    floatingLabel='Futures Price'
                                    type='text'
                                    id='futuresPrice'
                                    style={{width: 300,}}
                                    value={purchaseContractCashBid?.futures.lastPrice}
                                  />
                                </CCol>
                              ) : null
                            }
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                placeholder='Location...'
                                floatingLabel='Location'
                                type='text'
                                id='location'
                                style={{width: 300,}}
                                value={purchaseContractLocation?.locationName}
                              />
                            </CCol>
                            {
                              isMakeOfferInterface === false && (purchaseContractType === 'Priced' || purchaseContractType === 'Basis') ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    placeholder='Basis...'
                                    floatingLabel='Basis'
                                    type='text'
                                    id='basis'
                                    style={{width: 300,}}
                                    value={purchaseContractCashBid?.basis / 100}
                                  />
                                </CCol>
                              ) : null
                            }
                            {
                              isMakeOfferInterface === false && purchaseContractType === 'HTA' ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    floatingLabel='HTA Fee'
                                    type='text'
                                    id='htaFee'
                                    style={{width: 300,}}
                                    value={purchaseContractHTAFee}
                                  />
                                </CCol>
                              ) : null
                            }
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                placeholder='Commodity...'
                                floatingLabel='Commodity'
                                type='text'
                                id='commodity'
                                style={{width: 300,}}
                                value={purchaseContractCashBid?.commodity}
                              />
                            </CCol>
                            {
                              isMakeOfferInterface === false && purchaseContractType === 'Priced' ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    placeholder='Cash Price...'
                                    floatingLabel='Cash Price'
                                    type='text'
                                    id='cashPrice'
                                    style={{width: 300,}}
                                    value={'$' + purchaseContractCashBid?.cashprice}
                                  />
                                </CCol>
                              ) : null
                            }
                            {
                              isMakeOfferInterface === false && purchaseContractType === 'HTA' ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    floatingLabel='Contract Price'
                                    type='text'
                                    id='contractPrice'
                                    style={{width: 300,}}
                                    value={purchaseContractPrice}
                                  />
                                </CCol>
                              ) : null
                            }
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                placeholder='Delivery Start Date...'
                                floatingLabel='Delivery Start Date'
                                type='text'
                                id='startDate'
                                style={{width: 300,}}
                                value={moment(purchaseContractCashBid?.delivery_start).format('M/DD/YYYY')}
                              />
                            </CCol>
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                placeholder='Delivery End Date...'
                                floatingLabel='Delivery End Date'
                                type='text'
                                id='endDate'
                                style={{width: 300,}}
                                value={moment(purchaseContractCashBid?.delivery_end).format('M/DD/YYYY')}
                              />
                            </CCol>
                          </CRow>
                          <CRow className='mt-2 mb-3'>
                            <CCol xs={4}>
                              <CFormInput
                                disabled={true}
                                placeholder='Number of Bushels...'
                                floatingLabel='Number of Bushels'
                                type='number'
                                id='bushels'
                                style={{width: 300,}}
                                value={purchaseContractNumberOfBushels}
                              />
                            </CCol>
                            {
                              isMakeOfferInterface === true ? (
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    floatingLabel='Cash Price'
                                    type='number'
                                    id='offerCashPrice'
                                    style={{width: 300,}}
                                    value={offerCashPrice}
                                  />
                                </CCol>
                              ) : null
                            }
                          </CRow>
                          {
                            isMakeOfferInterface === true ? (
                              <CRow className='mt-2 mb-3'>
                                <CCol xs={4}>
                                  <CFormInput
                                    disabled={true}
                                    placeholder='Expiration Date...'
                                    floatingLabel='Expiration Date'
                                    type='text'
                                    id='expirationDate'
                                    style={{width: 300,}}
                                    value={moment(offerExpirationDate).format('M/DD/YYYY')}
                                  />
                                </CCol>
                              </CRow>
                            ): null
                          }
                          {
                            isMakeOfferInterface === false ? (
                              <>
                                <CRow className='mt-2 mb-3'>
                                  <CCol xs={4}>
                                    <CFormCheck 
                                      disabled={true}
                                      id='settleGrain' 
                                      label='Do you want this grain to be settled?'
                                      checked={purchaseContractSettleGrain}
                                    />
                                  </CCol>
                                  {
                                    purchaseContractType === 'Basis' || purchaseContractType === 'HTA' ? (
                                      <CCol xs={4}>
                                        <CFormCheck 
                                          disabled={true}
                                          id='purchaseContractApplyToExistingContract' 
                                          label='Do you want this contract to be applied against an existing contract?'
                                          checked={purchaseContractApplyToExistingContract}
                                          onChange={(e) => dispatch(setPurchaseContractApplyToExistingContract(e.target.checked))}
                                        />
                                      </CCol>
                                    ) : null
                                  }
                                </CRow>
                                <CRow className='mt-2 mb-3'>
                                  <CCol xs={4}>
                                    <CFormSelect 
                                      disabled={true}
                                      style={{width: 300,}}
                                      options={[
                                        {label: 'ACH', value: 'ACH',},
                                        {label: 'Check', value: 'Check',},
                                        {label: 'Deferred Payment', value: 'Deferred Payment',}
                                      ]}
                                      value={purchaseContractSettleGrainPaymentType}
                                    />
                                  </CCol>
                                  {
                                    purchaseContractType === 'Basis' || purchaseContractType === 'HTA' ? (
                                      <CCol xs={4}>
                                        <CFormInput
                                          disabled={true}
                                          floatingLabel='Existing Contract Number'
                                          type='text'
                                          id='purchaseContractExistingContractNumber'
                                          style={{width: 300,}}
                                          value={purchaseContractExistingContractNumber}
                                          onChange={(e) => dispatch(setPurchaseContractExistingContractNumber(e.target.value))} 
                                        />
                                      </CCol>
                                    ) : null
                                  }
                                </CRow>
                              </>
                            ) : null
                          }
                          {
                            purchaseContractComments !== '' ? (
                              <CRow>
                                <CCol xs={4}>
                                  <CFormTextarea
                                    disabled={true}
                                    type='text'
                                    id='readOnlyComments'
                                    style={{width: 700, height: 100,}}
                                    value={purchaseContractComments}
                                  />
                                </CCol>
                              </CRow>
                            ) : null
                          }
                        </div>
                      </div>
                      <div className='mt-5'>
                        <CButton
                          disabled={savingPurchaseContract}
                          color='primary'
                          onClick={() => dispatch(userCancelledPurchaseContract())}>
                          Cancel
                        </CButton>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <CLoadingButton 
                          loading={savingPurchaseContract}
                          type='submit'
                          color='primary'
                          onClick={() => isMakeOfferInterface === false ? dispatch(savePurchaseContract()) : dispatch(saveOffer())}>
                          {isMakeOfferInterface === false ? 'Submit Contract' : 'Submit Offer'}
                        </CLoadingButton>
                      </div>
                    </CForm>
                  </CCardBody>
                </CCard>
              </CContainer>
            </CTabPane>
          </CTabContent>
        </CModalBody>
      </CModal>
      <CModal
        alignment='center'
        visible={purchaseContractSuccessModalIsVisible}>
        <CModalHeader closeButton={false}>
          <CModalTitle className={styles.cashBidsModalTitle}>
            {
              isMakeOfferInterface === false ? 
                (newPurchaseContractNumber !== null ? 'Purchase Contract Created Successfully' : 'Purchase Contract Creation Failed') :
                (offerCreationSuccess === true ? 'Offer Created Successfully' : 'Offer Creation Failed')
            }
          </CModalTitle>
          <CButton className={styles.modalCloseButton} onClick={() => dispatch(hidePurchaseContractSuccessModal())}>
            <CIcon className={styles.modalCloseButtonIcon} icon={cilX} />
          </CButton>
        </CModalHeader>
        <CModalBody>
          {
            isMakeOfferInterface === false ? 
              (newPurchaseContractNumber !== null ? 'Your contract number is ' + newPurchaseContractNumber + '.' : 'Purchase Contract Creation Failed. Please try again later.') :
              (offerCreationSuccess === true ? 'Offer Created Successfully.' : 'Offer Creation Failed. Please try again later.')
          }
        </CModalBody>
      </CModal>
      <CModal
        alignment='center'
        visible={cancelOfferModalIsVisible}>
        <CModalHeader closeButton={false}>
          <CModalTitle className={styles.cashBidsModalTitle}>
            Cancel Offer
          </CModalTitle>
          <CButton className={styles.modalCloseButton} onClick={() => dispatch(hideCancelOfferModal())}>
            <CIcon className={styles.modalCloseButtonIcon} icon={cilX} />
          </CButton>
        </CModalHeader>
        <CModalBody>
          Are you sure you want to cancel this offer?
          <br/><br/>
          <CButton
            color='primary'
            variant='outline'
            onClick={() => dispatch(userCancelledOffer())}
            disabled={cancellingOffer}>
            {
              cancellingOffer === true ? (
                <CSpinner size='sm' />
              ) : null
            }
            {cancellingOffer === true ? ' Cancelling Offer' : 'Yes'}
          </CButton>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <CButton
            color='primary'
            variant='outline'
            onClick={() => dispatch(hideCancelOfferModal())}
            disabled={cancellingOffer}>
            No
          </CButton>
        </CModalBody>
      </CModal>
      <CModal
        alignment='center'
        visible={purchaseContractInvalidBushelsModalIsVisible}>
        <CModalHeader closeButton={false}>
          <CModalTitle className={styles.cashBidsModalTitle}>
            Purchase Contract Error
          </CModalTitle>
          <CButton className={styles.modalCloseButton} onClick={() => dispatch(hidePurchaseContractInvalidBushelsModal())}>
            <CIcon className={styles.modalCloseButtonIcon} icon={cilX} />
          </CButton>
        </CModalHeader>
        <CModalBody>
          Between the hours of 4PM CST & 7AM CST. The number of bushels per contract cannot exceed 25,000 bushels.
        </CModalBody>
      </CModal>
    </>
  );
}

export default PurchaseContractModal;
